// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Receipt24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Receipt24: FC<Receipt24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M10 17h7v-2h-7v2Zm-3-4h10v-2H7v2Zm0-4h10V7H7v2ZM3 21V5c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 3h14c.55 0 1.02.196 1.413.587C20.803 3.98 21 4.45 21 5v16H3Zm2-2h14V5H5v14Z" />
        </svg>
    );
};

export default Receipt24;
